(() => {
  // This script can be included by multiple section instances on the same page.
  // Guard it to avoid redeclaration errors.
  if (window.__metiProductIconStripScriptLoaded) {
    if (typeof window.__metiInitProductIconStrip === 'function') {
      window.__metiInitProductIconStrip();
    }
    return;
  }
  window.__metiProductIconStripScriptLoaded = true;

  class ProductIconStrip {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('.product-icon-strip__viewport');
      this.items = Array.from(section.querySelectorAll('.product-icon-strip__item'));
      this.dotsContainer = section.querySelector('.product-icon-strip__dots');
      this.mobileVisible = Number(section.dataset.mobileVisible) || 3;
      this.mobileStep = Number(section.dataset.mobileStep) || 2;
      this.pageStarts = [];
      this.ticking = false;

      if (!this.viewport || !this.dotsContainer || this.items.length === 0) return;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      this.setup();
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    getPageStarts() {
      const totalItems = this.items.length;
      if (totalItems <= this.mobileVisible) return [0];

      const starts = [];
      for (let index = 0; index <= totalItems - this.mobileVisible; index += this.mobileStep) {
        starts.push(index);
      }

      const lastStart = totalItems - this.mobileVisible;
      if (starts[starts.length - 1] !== lastStart) {
        starts.push(lastStart);
      }

      return starts;
    }

    buildDots() {
      this.dotsContainer.innerHTML = '';

      this.pageStarts.forEach((startIndex, dotIndex) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-icon-strip__dot';
        dot.setAttribute('aria-label', `Go to icon page ${dotIndex + 1}`);
        dot.addEventListener('click', () => {
          const targetItem = this.items[startIndex];
          if (!targetItem) return;
          this.viewport.scrollTo({
            left: targetItem.offsetLeft,
            behavior: 'smooth',
          });
        });
        this.dotsContainer.appendChild(dot);
      });
    }

    updateActiveDot() {
      if (!this.pageStarts.length) return;

      const currentScrollLeft = this.viewport.scrollLeft;
      let nearestDotIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      this.pageStarts.forEach((startIndex, dotIndex) => {
        const targetItem = this.items[startIndex];
        if (!targetItem) return;
        const distance = Math.abs(targetItem.offsetLeft - currentScrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestDotIndex = dotIndex;
        }
      });

      const dots = this.dotsContainer.querySelectorAll('.product-icon-strip__dot');
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === nearestDotIndex);
      });
    }

    setup() {
      if (!this.isMobile() || this.items.length <= this.mobileVisible) {
        this.pageStarts = [];
        this.dotsContainer.innerHTML = '';
        this.dotsContainer.hidden = true;
        return;
      }

      this.pageStarts = this.getPageStarts();
      this.buildDots();
      this.dotsContainer.hidden = this.pageStarts.length < 2;
      this.updateActiveDot();
    }

    handleScroll() {
      if (!this.isMobile() || this.pageStarts.length < 2) return;
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateActiveDot();
        this.ticking = false;
      });
    }

    handleResize() {
      this.setup();
    }
  }

  function initProductIconStrip() {
    const sections = document.querySelectorAll('.product-icon-strip');
    sections.forEach((section) => {
      if (section.dataset.iconStripInitialized === 'true') return;
      section.dataset.iconStripInitialized = 'true';
      new ProductIconStrip(section);
    });
  }

  window.__metiInitProductIconStrip = initProductIconStrip;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductIconStrip);
  } else {
    initProductIconStrip();
  }

  document.addEventListener('shopify:section:load', initProductIconStrip);
})();
